import {
	getController,
	apiService as Service,
	type HpRequestPostPut,
} from '@/services/service'

const url = 'faqs'

export const faqService = {
	...getController<Api.Faq, Api.FaqPostInput, Api.FaqUpdateInput>(url),
	update: (id: number, data: HpRequestPostPut<Api.FaqUpdateInput>) =>
		Service.post<Response>({ url: `${url}/${id}`, ...data }),
	ordering: (data: HpRequestPostPut<Api.FaqOrderingUpdateInput>) =>
		Service.post({
			url: `${url}/ordering`,
			...data,
			headers: {
				...data.headers,
				'Content-Type': 'multipart/form-data',
			},
		}),
	binary: (id: number, document_id: number, responseType: Api.ResponseType) =>
		Service.get({
			url: `${url}/${id}/documents/${document_id}/binary`,
			responseType,
		}),
}

export default faqService
